import { render, staticRenderFns } from "./OrganizationUserCreateMultiple.vue?vue&type=template&id=ef78c4b0&"
import script from "./OrganizationUserCreateMultiple.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserCreateMultiple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports